import { ServicesLoaders } from '@wix/thunderbolt-symbols'

export const serviceLoaders: ServicesLoaders = {
	testService: () => import('feature-test-service/service' /* webpackChunkName: "platformTestService" */),
}

export const servicesConfigs: { [serviceDefinition: string]: any } = {}
